import { getIDFromUrl, Url } from '@rossum/api-client';
import CopyToClipboardButton from '@rossum/components/copy-to-clipboard/CopyToClipboardButton';
import { Typography } from '@rossum/ui/material';
import { GridRenderCellParams } from '@rossum/ui/x-data-grid-pro';

const RenderIdentifier = (
  props: GridRenderCellParams<Record<never, never>, Url>
) => {
  const { value } = props;

  return (
    <Typography
      component="div"
      sx={{
        fontSize: 'inherit',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: '100%',
        verticalAlign: 'middle',
        display: 'inline-block',
      }}
    >
      {value ? (
        <CopyToClipboardButton
          content={getIDFromUrl(value).toString()}
          buttonProps={{
            color: 'inherit',
            size: 'small',
            sx: { fontFamily: 'monospace' },
          }}
        >
          {getIDFromUrl(value).toString()}
        </CopyToClipboardButton>
      ) : null}
    </Typography>
  );
};

export { RenderIdentifier };
